export default {
    GET_MY_FAVORITES_LOADING: 'GET_MY_FAVORITES_LOADING',
    GET_MY_FAVORITES_SUCCESS: 'GET_MY_FAVORITES_SUCCESS',
    GET_MY_FAVORITES_FAILED: 'GET_MY_FAVORITES_FAILED',
    GET_MY_FAVORITES_REJECT: 'GET_MY_FAVORITES_REJECT',

    NEW_FAVORITES_LOADING: 'NEW_FAVORITES_LOADING',
    NEW_FAVORITES_SUCCESS: 'NEW_FAVORITES_SUCCESS',
    NEW_FAVORITES_FAILED: 'NEW_FAVORITES_FAILED',
    NEW_FAVORITES_REJECT: 'NEW_FAVORITES_REJECT',
  };